import TextField, { TextFieldProps } from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    fontWeight: theme.typography.body1?.fontWeight,
  },
}));

const BaseTextField = ({ variant = 'standard', ...rest }: TextFieldProps) => (
  <StyledTextField variant={variant} {...rest} />
);

export type { TextFieldProps };
export default BaseTextField;
